import React from 'react'

const BreakfastIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.1771 10.3251L10.7333 9.82925L11.8708 6.69383L13.1104 9.24591C13.2465 9.50841 13.1882 9.77578 12.9354 10.048C12.6826 10.3202 12.4299 10.4126 12.1771 10.3251ZM8.51668 9.77091L9.14376 4.31675C9.1632 4.17091 9.22883 4.07126 9.34063 4.01779C9.45244 3.96432 9.58612 3.96189 9.74168 4.0105L11.2 4.55008C11.3361 4.60841 11.4261 4.69591 11.4698 4.81258C11.5136 4.92925 11.5111 5.05564 11.4625 5.19175L9.81459 9.77091H8.51668ZM4.20001 9.77091L2.55209 5.19175C2.50348 5.05564 2.50105 4.92682 2.5448 4.80529C2.58855 4.68376 2.67848 4.59869 2.81459 4.55008L4.27293 4.0105C4.40904 3.95216 4.53786 3.94973 4.65938 4.00321C4.78091 4.05668 4.8514 4.16119 4.87084 4.31675L5.48334 9.77091H4.20001ZM1.69168 10.3251C1.4389 10.4029 1.21043 10.3081 1.00626 10.0407C0.802093 9.77335 0.768065 9.50841 0.904176 9.24591L2.15834 6.69383L3.28126 9.82925L1.69168 10.3251ZM6.35834 9.77091L5.65834 3.50008C5.6389 3.3348 5.68508 3.19626 5.79689 3.08446C5.90869 2.97265 6.04723 2.91675 6.21251 2.91675H7.78751C7.95279 2.91675 8.09133 2.97265 8.20314 3.08446C8.31494 3.19626 8.36112 3.3348 8.34168 3.50008L7.64168 9.77091H6.35834Z'
      fill='currentColor'
    />
  </svg>
)

export default BreakfastIcon
